
import React from 'react';
import { Button } from '@/components/ui/button';

const NinjaOnePortalCard: React.FC = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
      <h3 className="text-lg font-semibold mb-4">NinjaOne Portal</h3>
      <p className="text-gray-600 mb-4">
        Access the NinjaOne dashboard to view your IT management services.
      </p>
      <Button 
        onClick={() => window.location.href = 'https://itmgmtsol.rmmservice.com'}
        className="w-full"
      >
        Access NinjaOne Portal
      </Button>
    </div>
  );
};

export default NinjaOnePortalCard;
